import { module } from 'constant'
import { createSelector } from 'selectors'

const { selector } = module.datamapImport

export const getContainerSelector = () => createSelector<HTMLElement>({ selector: selector.container })
const getModalSelector = (scope?: HTMLElement) => createSelector<HTMLElement>({ scope, selector: selector.modal })

export const getImportDatamapSelectors = () => {
	const scope = getContainerSelector()
	if (!scope) {
		return null
	}

	return {
		modal: getModalSelector(scope),
	}
}
